var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.iswhitestyle ? 'style-white' : '', 'know-more-button' ],on:{"click":_vm.btnClick}},[_c('i',{staticClass:"iconfont icon-circle"}),_c('span',[_vm._v(_vm._s(_vm.text ? _vm.text : _vm.$t('know_more')))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }